export default __webpack_public_path__ + "static/media/logo-white.4ea9b265.svg";